<template>
  <transition name="fade">
    <div
      class="dialog-box"
      v-if="props.visible"
      :style="{ backgroundColor: rootStyle['--bgColor'] }"
    >
      <div
        class="dialog-content"
        :style="{
          width: rootStyle['--width'],
          height: rootStyle['--height'],
          justifyContent,
        }"
      >
        <header v-if="props.header">
          <span class="dialog-title" v-if="props.title">{{ props.title }}</span>
          <span
            v-if="!props.hidenClose"
            @click="handleClose"
            class="iconfont icon-guanbiicon"
          ></span>
        </header>
        <header v-else>
          <slot name="header"></slot>
        </header>
        <div class="dialog-box-content">
          <slot></slot>
        </div>
        <div
          class="dialog-footer"
          :style="{ justifyContent: props.footerJustifyContent || 'center' }"
          v-if="props.footer"
        >
          <div class="btn">
            <span class="btn-cancel" v-if="props.cancelText"  @click="handleClose">{{
              props.cancelText
            }}</span>
            <span class="btn-confirm" v-if="props.confirmText" @click="handleConfirm">{{
              props.confirmText
            }}</span>
          </div>
        </div>
        <div v-else class="dialog-footer">
          <slot name="footer"></slot>
        </div>
        <template v-if="props.customCloseSlot">
          <slot name="customClose"></slot>
        </template>
      </div>
    </div>
  </transition>
</template>
<script setup lang="ts">
import { withDefaults, defineEmits, computed } from "vue";
import { t } from "@/locale";

type PropsType = {
  title?: string;
  modelValue?: string;
  visible: boolean;
  width?: string;
  height?: string;
  footer?: boolean;
  header?: boolean;
  confirmText?: string | boolean;
  cancelText?: string | boolean;
  bgColor?: any;
  hidenClose?: boolean;
  justifyContent?: string;
  footerJustifyContent?: string;
  customCloseSlot?:boolean
};

const props = withDefaults(defineProps<PropsType>(), {
  confirmText: `${t('dialog.save')}`,
  cancelText: `${t('dialog.cancel')}`,
  title: "",
  modelValue: "",
  visible: false,
  width: "800px",
  height: "500px",
  header: true,
  footer: true,
  bgColor: "rgba(0, 0, 0, .6)",
  justifyContent: "space-between",
});

const rootStyle = computed(() => ({
  "--width": props.width,
  "--height": props.height,
  "--bgColor": props.bgColor ?? "",
}));

const emits = defineEmits<{
  (e: "update:modelValue", val: string): void;
  (e: "close"): void;
  (e: "confirm"): void;
}>();

const handleConfirm = () => {
  emits("confirm");
};
const handleClose = () => {
  emits("close");
};
</script>
<style lang="less" scoped>
.icon-guanbiicon {
  font-size: 16px;
  cursor: pointer;
}
.dialog-box {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  // width: 100%;
  // height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  .dialog-content {
    position: relative;
    background: var(--vt-c-white);
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
    padding: 20px 24px 24px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .dialog-title {
      font-size: 18px;
      font-weight: 500;
      color: #1A1A1A;
      line-height: 22px;
    }
    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 500;
      span {
        cursor: pointer;
      }
    }
    .dialog-footer {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        display: flex;
        font-size: 16px;
        text-align: center;
        line-height: 36px;
        cursor: pointer;
        .btn-confirm {
          margin-left: 12px;
          width: 88px;
          font-weight: 500;
          height: 36px;
          background: #a9823e;
          color: #fff;
        }
        .btn-cancel {
          margin-right: 12px;
          width: 88px;
          font-weight: 500;
          height: 36px;
          border: 1px solid #cccccc;
          color: #666666;
        }
      }
    }
    .dialog-box-content {
      overflow-x: auto;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
